export default __webpack_public_path__ + "static/media/VO_ZK.d4c2ef75.gif";